export default __webpack_public_path__ + "static/icon-tile-size-dark-f0c16d5defc4b67dd40ed2089158e143c222cc5ba4d8710a87b00146253ffccd.png";